import { render, staticRenderFns } from "./Refun_product.vue?vue&type=template&id=6fc08b56&scoped=true&"
import script from "./Refun_product.vue?vue&type=script&lang=js&"
export * from "./Refun_product.vue?vue&type=script&lang=js&"
import style0 from "./Refun_product.vue?vue&type=style&index=0&id=6fc08b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc08b56",
  null
  
)

export default component.exports